import { useTheme } from "@repo/tokens";
import type { CardStyles, CardProps } from "./types";

export const useCardStyles = ({
  radius,
  borderColor,
  borderWidth,
  elevation = 0,
  backgroundColor,
  backgroundImage,
  noPadding,
  padding,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  width,
  height,
  style,
}: Partial<CardProps>): CardStyles => {
  const { theme } = useTheme();

  const shadowMap = {
    0: "none",
    1: theme.shadows.sm,
    2: theme.shadows.md,
    3: theme.shadows.lg,
    4: theme.shadows.xl,
  };

  const defaultPadding = noPadding ? 0 : (padding ?? theme.spacing.md);

  return {
    container: {
      borderRadius: radius ?? theme.control.radius.md,
      backgroundColor: backgroundColor ?? theme.surface.card,
      paddingTop: paddingTop ?? defaultPadding,
      paddingBottom: paddingBottom ?? defaultPadding,
      paddingLeft: paddingLeft ?? defaultPadding,
      paddingRight: paddingRight ?? defaultPadding,
      border:
        borderWidth && borderColor
          ? `${borderWidth}px solid ${borderColor}`
          : "none",
      boxShadow: shadowMap[elevation],
      backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
      backgroundSize: "cover",
      backgroundPosition: "center",
      width: width ? `${width}px` : "auto",
      height: height ? `${height}px` : "auto",
      ...style, // merge custom styles last
    },
  };
};
